export class EntityCV {

    public static all: EntityCV = new EntityCV();

    public OPERATOR = 'Operator';
    public OPERATOR_EMAIL = 'OperatorEmail';
    public OPERATOR_TRANSFER = 'OperatorTransfer';
    public AIRPORT = 'Airport';
    public AIRCRAFT = 'Aircraft';
    public SERVICE_TYPE = 'ServiceType';
    public COUNTRY = 'Country';
    public COUNTRY_GROUP = 'CountryGroup';
    public GROUP = 'Group';
    public ELEMENT_GROUP = 'ElementGroup';
    public USER = 'user';
    public ROLE = 'Role';
    public ROLE_PERMISSION = 'RolePermission';
    public PERMISSION = 'Permission';
    public FLIGHT = 'Flight';
    public FLIGHT_CATEGORY = 'FlightCategory';
    public SEASON = 'Season';
    public AIRPORT_SEASON = 'AirportSeason';
    public AIRPORT_EMAIL = 'AirportEmail';
    public AIRCRAFT_TYPE = 'AircraftType';
    public RESTRICTION = 'Restriction';
    public RESTRICTION_APPLICATION = 'RestrictionApplication';
    public RESTRICTION_APPLICATION_AIRCRAFT_TYPE_QUOTA = 'RestrictionApplicationAircraftTypeQuota';
    public RESTRICTION_APPLICATION_AIRLINE_QUOTA = 'RestrictionApplicationAirlineQuota';
    public RESTRICTION_APPLICATION_GROUP_QUOTA = 'RestrictionApplicationGroupQuota';
    public RESTRICTION_CRITERIA = 'RestrictionCriteria';
    public FLIGHT_GROUP = 'FlightGroup';
    public SERIES = 'Series';
    public TURNAROUND_SERIES = 'SSIMSeries';
    public INITIAL_COORDINATION_SERIES = 'InitialCoordinationSeries';
    public MOVEMENT = 'Movement';
    public TRANSACTION_LINE = 'TransactionLine';
    public HISTORIC_TRANSACTION_LINE = 'HistoricTransactionLine';
    public CONSTRAINT = 'Constraint';
    public TELEX = 'Telex';
    public TELEX_LINE = 'TelexLine';
    public TELEX_FOOTER_LINE = 'TelexFooterLine';
    public PARAMETER = 'Parameter';
    public ACTION = 'Action';
    public PARAMETER_AIRPORT_SEASON = 'ParameterAirportSeason';
    public PARAMETER_TEMPLATE = 'ParameterTemplate';
    public PHASE_TEMPLATE = 'PhaseTemplate';
    public COORDINATION_MESSAGE = 'CoordinationMessage';
    public NON_WORKING_DAY = 'NonWorkingDay';
    public OPERATIONAL_FLIGHT = 'OperationalFlight';
    public MAILBOX = 'Mailbox';
    public INITIAL_COORDINATION_PHASE = 'InitialCoordinationPhase';
    public REJECTION_REASON = 'RejectionReason';
    public AIRCRAFT_OPERATOR_LAYOVER_REDUCTION = 'AircraftOperatorLayoverReduction';
    public HANDLING_AGENT = 'HandlingAgent';
    public HANDLING_AGENT_EMAIL = 'HandlingAgentEmail';
    public GABA_RESTRICTION = 'GabaRestriction';
    public AIRPORT_OPERATOR_LAYOVER_EXCEPTION = 'AirportOperatorLayoverException';
    public PENDING_CRITERIA = 'PendingCriteria';
    public PENDING_CRITERIA_APPLICATION = 'PendingCriteriaApplication';
    public PENDING_CRITERIA_ASSIGNMENT = 'PendingCriteriaAssignment';
    public ASSOCIATED_FLIGHT = 'AssociatedFlight';
    public SHARED_OPERATION_RESTRICTION = 'SharedOperationRestriction';
    public SHARED_OPERATION = 'SharedOperation';
    public PORTAL_FILTER_PLATFORM = 'PortalFilterPlatform';
    public PORTAL_FILTER_LENGTH_ADVANCE = 'PortalFilterLengthAdvance';
    public PORTAL_FILTER_SPECIAL_EVENT = 'PortalFilterSpecialEvent';
    public MILESTONE = "Milestone";
    public CRITICAL_FLIGHT_CRITERIA = "CriticalFlightCriteria";
    public SLOT_RESERVATION = "SlotReservation";
    public PASSENGERS_FLOW = "PassengersFlow";
    public MANAGED_AIRPORT = "ManagedAirport";
    public USUAL_TEXT_LINE = "UsualTextLine";
    public PENDING_NP = "PendingNP"
    public FLIGHT_MONITORING = "FlightMonitoring";
    public PAM_RESPONSE = 'PamResponse';
    public PAM_FILTER = 'PamFilter';
    public TELEX_SI_INFO_TAG = 'TelexSiInfoTag';
    public TELEX_SIGNATURE = 'TelexSignature'
    public WORKLOG = "Worklog";

    constructor() {
    }
}
